module.exports = __webpack_public_path__ + "img/vertical_stacked_bar_chart.f46ba3b8.svg";